<script setup lang="ts">
import InlineSvg from 'vue-inline-svg'
import type { NuxtError } from '#app'
import { defineAsyncComponent } from 'vue'

const NotFound = defineAsyncComponent(() => import('@b2ag/not-found'))

const { error } = defineProps({
  error: Object as () => NuxtError,
})

const isNotFound = error?.statusCode === 404

const formatStack = (stack: string | undefined): string => {
  if (!stack) return ''
  return stack.replace(/\) at /g, ')\n at ')
}

const title = !isNotFound ? error?.statusCode + '' : undefined
const message = !isNotFound ? error?.message || error?.statusMessage : undefined
const displayDefaultSVG = !isNotFound ? 'none' : 'block'
</script>

<template>
  <div class="error-page">
    <inline-svg v-if="!isNotFound" src="/themes/current/images/no_search_result.svg" alt="Error page" />
    <Suspense>
      <NotFound :title="title" :message="message" />
    </Suspense>
  </div>

  
</template>

<style lang="scss" scoped>
.error-page {
  text-align: center;
  padding-top: var(--spacing-6);
}
:deep(.v-not-found) {
  height: auto !important;

  .svg_wrapper {
    display: v-bind(displayDefaultSVG);
  }
}
.dev-mode {
  margin-top: var(--spacing-3);
  margin-left: var(--spacing-4);
}
.stack-trace {
  white-space: pre-wrap;
  font-family: monospace;
  text-align: left;
}
</style>
